import { render, staticRenderFns } from "./Ipc.vue?vue&type=template&id=62ae5bc0&scoped=true&"
import script from "./Ipc.vue?vue&type=script&lang=ts&"
export * from "./Ipc.vue?vue&type=script&lang=ts&"
import style0 from "./Ipc.vue?vue&type=style&index=0&id=62ae5bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae5bc0",
  null
  
)

export default component.exports